import { Injectable } from '@angular/core';
import { MatSnackBar } from '../material';

@Injectable({
  providedIn: 'root',
})
export class HbgSnackBar {
  constructor(private snackBar: MatSnackBar) {}

  open(message: string, action: string = null, config: any = {}) {
    this.snackBar.open(message, action, config);
  }

  error(message: string, action: string = null, config: any = {}) {
    const errorConfig = {
      ...config,
      panelClass: ['error-toast', ...(config.panelClass || [])],
    };
    this.snackBar.open(message, action, errorConfig);
  }

  stickyError(message: string, config: any = {}) {
    const stickyConfig = {
      duration: 0,
      ...config,
      panelClass: [
        'error-toast',
        'sticky-toast',
        'has-icon',
        ...(config.panelClass || []),
      ],
    };
    const snackBarRef = this.snackBar.open(message, '✕', stickyConfig);

    snackBarRef.onAction().subscribe(() => {
      snackBarRef.dismiss();
    });

    return snackBarRef;
  }
}
